import { createContext } from 'react'

export interface DarkModeContextType {
  darkMode: boolean
  setDarkMode: (darkMode: boolean) => void
}

export const DarkModeContext = createContext<DarkModeContextType>({
  darkMode: false,
  setDarkMode: () => {}
})
